/**
 * Chatwoot utility for conditional loading
 * Follows the same enable/disable logic as Sentry and GTM
 */

const isProduction = import.meta.env.MODE === 'production';
const chatwootEnabled = import.meta.env.VITE_CHATWOOT_ENABLED === 'true' || isProduction;
const chatwootToken = import.meta.env.VITE_CHATWOOT_TOKEN || 'Cjiki2wRJmQNQdXQuyryBwBp';
const chatwootBaseUrl = import.meta.env.VITE_CHATWOOT_BASE_URL || 'https://app.chatwoot.com';

let initialized = false;

export const initializeChatwoot = (userData?: {
  user_id?: string;
  name?: string;
  email?: string;
  identifier_hash?: string;
}) => {
  if (!chatwootEnabled || initialized) {
    return;
  }

  // Configure widget settings before loading SDK
  (window as any).chatwootSettings = {
    hideMessageBubble: true,
    position: 'right',
    locale: 'en',
    type: 'standard',
  };

  // Once widget is ready: set user info and fix z-index/opacity
  window.addEventListener('chatwoot:ready', () => {
    if (window.$chatwoot && userData) {
      window.$chatwoot.setUser(userData.user_id || '', {
        name: userData.name,
        email: userData.email,
        identifier_hash: userData.identifier_hash,
      });
    }

    // Ensure the chat panel renders above the app when opened from sidebar
    const style = document.createElement('style');
    style.textContent = `
      .woot-widget-holder { z-index: 10000 !important; opacity: 1 !important; }
    `;
    document.head.appendChild(style);
  }, { once: true });

  // Dynamically load the Chatwoot SDK script
  const script = document.createElement('script');
  script.src = `${chatwootBaseUrl}/packs/js/sdk.js`;
  script.defer = true;
  script.async = true;
  script.onload = () => {
    if (window.chatwootSDK) {
      window.chatwootSDK.run({
        websiteToken: chatwootToken,
        baseUrl: chatwootBaseUrl,
      });
    }
  };
  document.body.appendChild(script);
  initialized = true;
};

export const toggleChatwoot = () => {
  if (!chatwootEnabled) return;
  if (window.$chatwoot) {
    window.$chatwoot.toggle();
  }
};

export const openChatwoot = () => {
  if (!chatwootEnabled) return;
  if (window.$chatwoot) {
    window.$chatwoot.toggle('open');
  }
};

export const closeChatwoot = () => {
  if (!chatwootEnabled) return;
  if (window.$chatwoot) {
    window.$chatwoot.toggle('close');
  }
};

export const chatwootConfig = {
  enabled: chatwootEnabled,
  token: chatwootToken,
  baseUrl: chatwootBaseUrl,
};
